import { render } from "./CustomDialogModal.vue?vue&type=template&id=6baed4b5"
import script from "./CustomDialogModal.vue?vue&type=script&lang=js"
export * from "./CustomDialogModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__